import styled from 'styled-components';
import { flexCenter } from '../../../../helpers/style-helpers';

type TVitalChartSC = {
  isMini?: boolean;
};
export const VitalChartSC = styled.div<TVitalChartSC>`
  ${flexCenter}

  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto;

  transform-origin: center;

  ${({ isMini }) => {
    if (isMini) {
      return 'transform: scale(0.6) translate(-32%, -32%);';
    }
  }}

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 80px;
  }

  .vc-data {
    text-align: center;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.25;

    b {
      display: block;
      font-weight: 800;
      font-size: 14px;
    }
  }

  .vc-empty-label {
    font-size: 12px;
    color: #293157;
  }
`;
